



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetProductList,
  PostProductDetail,
  DeleteProduct,
  GetProductDetail,
} from "@/request/system";
import ProductDetail from "./product-detail.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
    Pagination,
    ProductDetail,
  },
})
export default class SystemProduct extends Vue {
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "0";
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private products: any[] = [];
  // 详情
  private ifShowDetail: boolean = false;
  private tempProduct: any = {
    数据中心: {
      choice: false,
      values: {
        专病数据库: false,
        研究项目: false,
        CRF量表: false,
        数据字典: false,
        数据看板: false,
      },
    },
    研究工具: {
      choice: false,
      values: {
        智能看舌: false,
        智能看脉: false,
      },
    },
    分析挖掘: {
      choice: false,
      values: {
        舌图特征分析: false,
        脉图特征分析: false,
        专家经验挖掘: false,
        自定义分析: false,
      },
    },
    AI训练: {
      choice: false,
      values: {
        我的模型: false,
        创建模型: false,
        模型训练: false,
        模型试用: false,
      },
    },
    AI应用: {
      choice: false,
      values: {
        名医AI: false,
        中医舌诊AI: false,
        中成药辅助辨证AI: false,
        中医慢病管理AI: false,
      },
    },
    知识库: {
      choice: false,
      values: {
        知识全库: false,
        舌诊知识库: false,
        脉诊知识库: false,
        专病知识库: false,
        方药知识库: false,
        古籍知识库: false,
      },
    },
    舌诊教学: {
      choice: false,
      values: {
        舌诊教材: false,
        典型舌图: false,
        舌诊实训: false,
        舌诊考试: false,
        实训薄弱分析: false,
        组织在线舌诊考试: false,
      },
    },
    教学管理: {
      choice: false,
      values: {
        习题库: false,
        试卷库: false,
        考试管理: false,
        班级管理: false,
      },
    },
    其它功能: {
      choice: true,
      values: {
        导出记录: true,
        回收站: true,
        用户管理: true,
      },
    },
  };
  /**
   * @description 获得产品列表
   */
  private getProducts() {
    const params: any = {
      current_page: this.currentPage,
      page_count: this.pageSize,
      order_field: this.cSortField,
      order_value: this.cSortValue,
    };
    GetProductList(this, params).then((data: any) => {
      this.products = data.products;
      this.totalPage = data.total_page;
      this.totalCount = data.total_count;
    });
  }
  /**
   * @description 新增产品
   */
  private addProduct() {
    this.tempProduct = {
      数据中心: {
        choice: false,
        values: {
          专病数据库: false,
          研究项目: false,
          CRF量表: false,
          数据字典: false,
          数据看板: false,
        },
      },
      研究工具: {
        choice: false,
        values: {
          智能看舌: false,
          智能看脉: false,
        },
      },
      分析挖掘: {
        choice: false,
        values: {
          舌图特征分析: false,
          脉图特征分析: false,
          专家经验挖掘: false,
          自定义分析: false,
        },
      },
      AI训练: {
        choice: false,
        values: {
          我的模型: false,
          创建模型: false,
          模型训练: false,
          模型试用: false,
        },
      },
      AI应用: {
        choice: false,
        values: {
          名医AI: false,
          中医舌诊AI: false,
          中成药辅助辨证AI: false,
          中医慢病管理AI: false,
        },
      },
      知识库: {
        choice: false,
        values: {
          知识全库: false,
          舌诊知识库: false,
          脉诊知识库: false,
          专病知识库: false,
          方药知识库: false,
          古籍知识库: false,
        },
      },
      舌诊教学: {
        choice: false,
        values: {
          舌诊教材: false,
          典型舌图: false,
          舌诊实训: false,
          舌诊考试: false,
          实训薄弱分析: false,
          组织在线舌诊考试: false,
        },
      },
      教学管理: {
        choice: false,
        values: {
          习题库: false,
          试卷库: false,
          考试管理: false,
          班级管理: false,
        },
      },
      其它功能: {
        choice: true,
        values: {
          导出记录: true,
          回收站: true,
          用户管理: true,
        },
      },
    };
    this.ifShowDetail = true;
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.getProducts();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    switch (ev["prop"]) {
      case "create_time":
        this.cSortField = "创建时间";
        break;
      case "update_time":
        this.cSortField = "更新时间";
        break;
    }
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.getProducts();
  }
  /**
   * @description 编辑
   */
  private composeThis(product) {
    this.tempProduct = product;
    if (!this.tempProduct["教学管理"]) {
      this.$set(this.tempProduct, "教学管理", {
        choice: false,
        values: {
          习题库: false,
          试卷库: false,
          考试管理: false,
          班级管理: false,
        },
      });
    }
    if (!this.tempProduct["教学管理"]["values"]) {
      this.$set(this.tempProduct, "教学管理", {
        choice: false,
        values: {
          习题库: false,
          试卷库: false,
          考试管理: false,
          班级管理: false,
        },
      });
    }
    // console.log(this.tempProduct);
    this.ifShowDetail = true;
  }
  /**
   * @description 关闭详情
   */
  private closeDetail() {
    this.ifShowDetail = false;
    this.getProducts();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getProducts();
  }
}
